/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiTransformFromJSON, StreemApiTransformToJSON, } from './';
export function WallItemARElementTextFromJSON(json) {
    return WallItemARElementTextFromJSONTyped(json, false);
}
export function WallItemARElementTextFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'transform': !exists(json, 'transform') ? undefined : StreemApiTransformFromJSON(json['transform']),
        'rotation': !exists(json, 'rotation') ? undefined : json['rotation'],
        'text': !exists(json, 'text') ? undefined : json['text'],
    };
}
export function WallItemARElementTextToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'transform': StreemApiTransformToJSON(value.transform),
        'rotation': value.rotation,
        'text': value.text,
    };
}
//# sourceMappingURL=WallItemARElementText.js.map